import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import '../letterstyles/JoiningLetter.css';

const JoiningLetter = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const handlePrint = useReactToPrint({
     contentRef: printRef,
     documentTitle: 'Joining_Letter',
  });

 const handleDownloadPDF = () => {
  const element = printRef.current;

  const opt = {
    margin: [5, 5, 5, 5],
    filename: "Joining_Letter.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 3,
      useCORS: true,
      allowTaint: true,
      logging: false,
      dpi: 300,
      letterRendering: true,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compressPdf: true,
    },
  };

   html2pdf().set(opt).from(element).save();
  };

  useEffect(() => {
    if (!state?.user) {
      alert("No user data provided");
      navigate('/');
    }

    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
          }
          setCompany(data);
        } else {
          console.error('Failed to fetch company data');
        }
      } catch (err) {
        console.error('Error fetching company details:', err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [navigate, state?.user, superAdminId]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const user = state?.user;
  if (!user) return null;
  if (loading) return <p>Loading company details...</p>;

  return (
    <div className="letter-wrapper">
      
       <div ref={printRef}>
          <div className="joining-letter">
        <div className="letter-header">
          <img 
            src={company?.logoUrl || '/default-logo.png'} 
            alt="Company Logo" 
            className="letter-logo" 
          />
          <div className="letter-company-info"  style={{ textAlign: 'center' }}>
            <h2>{company?.name}</h2>
            <p><strong>Regt. Office:</strong> {company?.address}</p>
            <p><strong>CIN:</strong> {company?.cin}</p>
            <p><strong>Email:</strong> {company?.email}</p>
            <p><strong>Contact:</strong> {company?.contact || 'N/A'}</p>
          </div>
          <img
            style={{ opacity: 0 }}
            src={company?.logoUrl || "/default-logo.png"}
            alt="Company Logo"
            className="letter-logo"
          />
        </div>

        <div className="letter-body">
          <p style={{ textAlign: 'right' }}>
            {/* ✅ Fixed: use actual joining date instead of today */}
            <strong>Date:</strong> {formatDate(user.dateOfJoining)}
          </p>
          <p>To,</p>
          <p><strong>{user.name}</strong></p>
          <p>{user.branch}</p>
          <p><strong>Employee ID:</strong> {user.userId}</p>
          <p><strong>Subject:</strong> Appointment for the position of {user.roleName}</p>
          <p><strong>Dear {user.fullName},</strong></p>

          <p>We are pleased to offer you the position of <strong>{user.roleName}</strong> at <strong>{company?.name}</strong> based at our <strong>{user.branch}</strong> branch. Your skills and experience will be a valuable addition to our team.</p>

          <p><strong>Terms and Conditions of Employment:</strong></p>
          <ol>
            {/* ✅ Fixed: use actual joining date instead of today */}
            <li><strong>Joining Date:</strong> {formatDate(user.dateOfJoining)}</li>
            <li><strong>Salary:</strong> Will be shared in your appointment pack.</li>
            <li><strong>Probation Period:</strong> 6 months with review.</li>
            <li><strong>Working Hours:</strong> 9:30 AM – 6:30 PM, Mon–Sat.</li>
            {/* <li><strong>Leave:</strong> 12 paid leaves annually + holidays.</li> */}
            <li><strong>Code of Conduct:</strong> Maintain professionalism and policy compliance.</li>
            <li><strong>Termination:</strong> 1 month notice from either side.</li>
            <li><strong>Confidentiality:</strong> Protect company information.</li>
            <li><strong>Location:</strong> Transferable across branches.</li>
            <li><strong>Documents:</strong> Submit Aadhaar, PAN, education proof and 2 Cheques on joining.</li>
          </ol>

          <p>We look forward to your acceptance and welcome you aboard!</p>

          <div className='no-break'>
              <p><strong>Sincerely,</strong></p>
              <br />
              <p><strong></strong><br />
                HR Manager<br />
                {company?.name}</p>
          </div>
        </div>

        <div className="letter-footer">
          <hr />
          <p>{company?.name} | CIN: {company?.cin}</p>
          <p>Email: {company?.email} | Address: {company?.address}</p>
        </div>
          </div>
       </div>
       <div className="letter-actions">
        <button onClick={handlePrint} className="letter-action-button">Print</button>
        <button onClick={handleDownloadPDF} className="letter-action-button">Download</button>
      </div>

    </div>
  );
};

export default JoiningLetter;